import React from "react";

const ExceptionReports = ({ exceptions }) => (
    <section className="card">
        <h3>Exception Reports</h3>
        <ul>
            {exceptions.map((e, i) => (
                <li key={i}>{e.message}</li>
            ))}
        </ul>
    </section>
);

export default ExceptionReports;